import * as React from "react";

const SvgIcnHoldOff = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M5.186 15.856l13.128-7.578c.2-.117.476-.017.614.222.138.24.087.527-.114.644L5.686 16.722c-.2.117-.476.017-.614-.222-.138-.24-.087-.527.114-.644zM11 15.45V18a1 1 0 01-1 1H8a1 1 0 01-1-1v-.256l4-2.294zm6-3.486V18a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3.708l4-2.328zM8 5h2a1 1 0 011 1v4.96l-4 2.293V6a1 1 0 011-1zm6 0h2a1 1 0 011 1v1.5l-4 2.311V6a1 1 0 011-1z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnHoldOff;
